// ────────────────────────────
// src/components/FreeTrialContactSection.jsx
// Caja centrada con bg de la hero + CTA “Empieza gratis”
// ────────────────────────────
import React, { useCallback } from 'react';
import './FreeTrialContactSection.css';
import { FaQuestionCircle } from 'react-icons/fa';
// import { RiUserAddLine, RiSendPlane2Line, RiFileCheckLine } from 'react-icons/ri';

const APP_URL =
  process.env.REACT_APP_APP_URL || 'https://app.zasfit.io';

export default function FreeTrialContactSection() {

  const openTidio = useCallback((e) => {
    e.preventDefault();                         // evita el salto de página
    const run = () => window.tidioChatApi?.open();
    if (window.tidioChatApi) {
      run();                                    // el script ya está listo
    } else {
      document.addEventListener('tidioChat-ready', run, { once: true });
    }
  }, []);

  return (
    <section id="contact" className="contact-section z-2 pt-20 pb-0">
      <div className="container">
        {/* ── Caja con fondo de captura ── */}
        <div
          className="
            contact-box wow animate__animated animate__fadeInUpShort text-white
          "
          data-wow-delay="0.05s"
        >
          <div className="lines">
            <div className="line"></div>
            <div className="line"></div>
          </div>

          {/* línea superior */}
          <span
            className="
              sub-title sub-title-with-margin-bottom wow animate__animated animate__fadeInUpShort
            "
            data-wow-delay="0.1s"
          >
            Prueba Gratis
          </span>

          {/* título */}
          <h2
            className="
             section-hook mb-20 wow animate__animated animate__fadeInUpShort
            "
            data-wow-delay="0.2s"
          >
            Empieza gratis ahora
          </h2>
          
          <p
            className="
              contact-text mb-5 wow animate__animated animate__fadeInUpShort
            "
            data-wow-delay="0.3s"
          >
            Crea tu cuenta y empieza a escalar tu negocio.
          </p>

          <p
            className="
              contact-text wow animate__animated animate__fadeInUpShort
            "
            data-wow-delay="0.4s"
          >
            ¿Tienes dudas? Escríbenos y te ayudaremos encantados.
          </p>

          {/* CTAs */}
          <div
            className="
              contact-cta d-flex flex-wrap justify-content-center gap-3
              wow animate__animated animate__fadeInUpShort
            "
            data-wow-delay="0.40s"
          >
            {/* CTA principal – amarillo */}
            <a
              href={`${APP_URL}/auth/register`}
              className="theme-btn style-five btn-start btn-start-free-trial contact"
            >
              Prueba Gratis 7 días
            </a>

            {/* CTA secundario – borde blanco + icono sólido FA */}
            <a
              href="#chat"
              onClick={openTidio}
              className="theme-btn style-five btn-contact btn-start-free-trial d-inline-flex align-items-center"
            >
              <FaQuestionCircle className="btn-icon" aria-hidden="true" />
              <span>Contacta</span>
            </a>
          </div>
        </div>
      </div>

      {/* decoraciones */}
      <div className="bg-yellow-shape3" />
    </section>
  );
}
